// extracted by mini-css-extract-plugin
export var brush1 = "brushImage-module--brush1--2jEoq";
export var brush2 = "brushImage-module--brush2--28jX9";